import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { Icon } from "@circle-react-shared/Icon";
import { BlockActionButton } from "./BlockActionButton";

export const MoveUp = () => {
  const { canMoveUp, moveSelectedBlock } = useSelectedBlock();

  return (
    <BlockActionButton
      onClick={() => moveSelectedBlock("up")}
      disabled={!canMoveUp}
      title={t("builder_ui.editor.move_up")}
    >
      <Icon type="16-arrow-up" size={16} />
    </BlockActionButton>
  );
};
